<template>
  <el-main>
    <!-- #region 基本資料 -->
    <el-row>
      <el-form :model="userInfo" class="demo-ruleForm" status-icon>
        <el-col :span="20" :offset="2">
          <el-row class="block-div">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col>
                <h3 style="d-flex">基本資料</h3>
              </el-col>
              <el-col class="formSubmitBtnBox">
                <el-button style="margin: 10px;" @click="cancal()">取消</el-button>
                <el-button type="primary" style="margin: 10px;" @click="updateUserInfos()">儲存</el-button>
              </el-col>
            </el-row>
            <br />
            <el-col :span="10">
              <div v-if="this.$route.params.userId !== null" align="center">
                <img :src="userInfo.photoUrl" alt="原照片" class="userInfo-img" />
              </div>
              <el-form-item label="更換照片" prop="picture" class="upload-div">
                <PictureUploader :fileQuantityLimit="1" :fileList.sync="fileList"></PictureUploader>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="姓名" prop="name" style="margin:0 28px 20px">
                <el-input style="width:300px" type="text" v-model.trim="userInfo.name" autocomplete="off" maxlength="150" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="性別" prop="gender" style="margin:0 28px 20px">
                <el-radio-group v-model="userInfo.gender">
                  <el-radio label="男">男</el-radio>
                  <el-radio label="女">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="聯絡手機" prop="phone">
                <el-input style="width:300px" type="text" v-model.trim="userInfo.phone" autocomplete="off" maxlength="150" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="生日" prop="startDate" style="margin:0 28px 20px">
                <el-date-picker style="width:300px" v-model="userInfo.birthday" type="date" value-format="yyyy/MM/dd"></el-date-picker>
                {{ userInfo.startDate }}
              </el-form-item>
              <el-form-item label="預設密碼" prop="PwdDefault">
                <el-input style="width:300px" type="text" v-model.trim="userInfo.pwdDefault" autocomplete="off" maxlength="50" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="使用者更改密碼" prop="PwdChanged">
                <div>
                  {{ userInfo.pwdChanged ? '已自行更改' : '尚未自行更改' }}
                  <i :class="userInfo.pwdChanged ? 'el-icon-check' : 'el-icon-close'"></i>
                </div>
              </el-form-item>
              <el-form-item label="電子信箱" prop="email">
                <el-input style="width:300px" type="text" v-model.trim="userInfo.email" autocomplete="off" maxlength="150" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="聯絡地址" prop="address">
                <span>{{ userInfo.city }} {{ userInfo.dist }} </span>
                <el-input style="width:210px" type="text" v-model.trim="userInfo.address" autocomplete="off" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-form>
    </el-row>
    <!-- #endregion -->

    <!-- #region 相關證照 -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-row class="block-div">
          <el-col :span="24">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col>
                <h3 style="d-flex">相關證照</h3>
              </el-col>
            </el-row>
            <br />

            <div v-if="this.certificateList.length < 1" align="center">
              尚未取得證照
            </div>
            <el-tabs v-else v-model="active" type="border-card">
              <el-tab-pane v-for="(item, index) in certificateList" :key="index" :label="index === 0 ? '工業總會證照' : '協會證照'" :name="item.$index">
                <el-form :model="item" class="demo-ruleForm" status-icon>
                  <el-col class="formSubmitBtnBox" style="margin:0 0 10px">
                    <el-button style="margin: 10px;" @click="cancal()">取消</el-button>
                    <el-button type="primary" style="margin: 10px;" @click="updateCertificateInfos(item.id)">儲存</el-button>
                  </el-col>
                  <el-col :span="10">
                    <div align="center">
                      <img :src="item.photoUrl" alt="原照片" class="userInfo-img" />
                    </div>
                    <el-form-item label="更換照片" prop="picture" class="upload-div">
                      <PictureUploader :fileQuantityLimit="1" :fileList.sync="cfileList"></PictureUploader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14">
                    <el-form-item label="發證單位" prop="issueHost">
                      <el-input style="width:300px" type="text" v-model.trim="item.issueHost" autocomplete="off" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="證照日期" prop="date">
                      <el-date-picker style="width:300px" v-model="item.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="證照號碼" prop="number">
                      {{ item.editableNumber !== null ? item.editableNumber : item.number }}
                    </el-form-item>
                    <el-form-item label="證照狀態" prop="status">
                      <span class="certStatusT" v-if="item.status">有效</span>
                      <span class="certStatusF" v-else>無效</span>
                    </el-form-item>
                    <el-form-item label="證照校期" prop="address"> {{ item.date }} ~ {{ item.term }} </el-form-item>
                  </el-col>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- #endregion -->

    <!-- #region 相關紀錄 -->
    <el-row>
      <el-col :span="20" :offset="2">
        <el-row class="block-div">
          <h3 style="d-flex">相關紀錄</h3>
          <br />
          <el-tabs type="border-card">
            <!-- #region 培訓紀錄-->
            <el-tab-pane label="培訓紀錄">
              <!-- 按鈕 -->
              <div style="font-size: 14px; color:red">( 若該培訓已報名考試，則無法刪除，請使用編輯功能 )</div>
              <el-row style=" margin: 24px 0">
                <el-col :span="12"><el-button style="margin: 0 12px 0 0" icon="el-icon-delete-solid" @click="DeleteTrainingRecored()"></el-button>選擇並刪除</el-col>
                <el-col :span="12" align="right">
                  <el-button type="primary" style="margin:0 15px" @click="trainingRecordForm.dialogVisible = true">新增</el-button>
                </el-col>
              </el-row>
              <!-- 表格 -->
              <el-table
                v-loading="loading"
                :data="trainingRecordList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                :default-sort="{
                  prop: 'invitedTimes,sort,startDate',
                  order: 'descending',
                }"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="" fixed width="10"> </el-table-column>
                <el-table-column label="培訓日期" fixed>
                  <template slot-scope="scope">
                    <div>{{ scope.row.date }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="培訓單位" min-width="200">
                  <template slot-scope="scope">
                    <div>{{ scope.row.host }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="講師">
                  <template slot-scope="scope">
                    <div>{{ scope.row.lecturerName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="培訓狀態">
                  <template slot-scope="scope">
                    <div :class="scope.row.status ? 'certStatusT' : 'certStatusF'">
                      <p v-if="scope.row.status">有效</p>
                      <p v-else style="color: #F56C6C;">失效</p>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="時數">
                  <template slot-scope="scope">
                    <div>{{ scope.row.hours }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click="EditTrainingRecord(scope.row.id)">編輯</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分頁 -->
              <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100]" :page-size="pagesize" layout="total, sizes,prev, pager, next" :total="trainingRecordList.length" prev-text="上一頁" next-text="下一頁"> </el-pagination>
              </div>
            </el-tab-pane>
            <!-- #endregion -->
            <!-- #region 證照複訓紀錄-->
            <el-tab-pane label="證照複訓紀錄">
              <!-- 按鈕 -->
              <el-row style="margin: 24px 0 24px 0">
                <el-col :span="12"><el-button style="margin: 0 12px 0 0" icon="el-icon-delete-solid" @click="DeleteReTrainingRecored()"></el-button>選擇並刪除</el-col>
                <el-col :span="12" align="right">
                  <el-button type="primary" @click="reTrainingRecordForm.dialogVisible = true">新增</el-button>
                </el-col>
              </el-row>
              <!-- 表格 -->
              <el-table
                v-loading="loading2"
                :data="reTrainingRecordList.slice((currentPage2 - 1) * pagesize, currentPage2 * pagesize)"
                style="width: 100%"
                @selection-change="handleSelectionChange2"
                :default-sort="{
                  prop: 'invitedTimes,sort,startDate',
                  order: 'descending',
                }"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="培訓日期" fixed>
                  <template slot-scope="scope">
                    <div>{{ scope.row.dateFormate }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="" align="right">
                  <template slot-scope="scope">
                    <el-button @click="EditReTrainingRecord(scope.row.id)">編輯</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分頁 -->
              <div class="pagination">
                <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="currentPage2" :page-sizes="[10, 50, 100]" :page-size="pagesize" layout="total, sizes,prev, pager, next" :total="reTrainingRecordList.length" prev-text="上一頁" next-text="下一頁"> </el-pagination>
              </div>
            </el-tab-pane>
            <!-- #endregion -->
            <!-- #region 報名紀錄-->
            <el-tab-pane label="報名紀錄">
              <!-- 表格 -->
              <el-table
                v-loading="loading3"
                :data="examInfoList.slice((currentPage3 - 1) * pagesize, currentPage3 * pagesize)"
                style="width: 100%"
                @selection-change="handleSelectionChange3"
                :default-sort="{
                  prop: 'invitedTimes,sort,startDate',
                  order: 'descending',
                }"
              >
                <el-table-column label="報名日期" fixed>
                  <template slot-scope="scope">
                    {{ scope.row.registDateFormate }}
                  </template>
                </el-table-column>
                <el-table-column label="證件照片">
                  <template slot-scope="scope">
                    <el-image fit="contain" style="width: 100px; height: 100px" :src="scope.row.photoUrl" :preview-src-list="[scope.row.photoUrl]"></el-image>
                  </template>
                </el-table-column>
                <el-table-column label="考試地點">
                  <template slot-scope="scope">
                    {{ scope.row.examLocation }}
                  </template>
                </el-table-column>
                <el-table-column label="考試地址" min-width="180">
                  <template slot-scope="scope">
                    {{ scope.row.examAddress }}
                  </template>
                </el-table-column>
                <el-table-column label="匯款人">
                  <template slot-scope="scope">
                    {{ scope.row.remitName }}
                  </template>
                </el-table-column>
                <el-table-column label="匯款末5碼" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.remitNumber }}
                  </template>
                </el-table-column>
                <el-table-column label="匯款憑證" width="150">
                  <template slot-scope="scope">
                    <el-image fit="contain" style="width: 100px; height: 100px" :src="scope.row.remitUrl" :preview-src-list="[scope.row.remitUrl]"></el-image>
                    <a :href="scope.row.remitUrl" style="text-decoration:none;">下載</a>
                  </template>
                </el-table-column>
                <el-table-column label="繳費" width="50">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.remitStatus"></el-checkbox>
                  </template>
                </el-table-column>

                <el-table-column label="准考證號碼" width="120" prop="examNumber" sortable>
                  <template slot-scope="scope">
                    <p v-if="scope.row.remitStatus">
                      {{ scope.row.examNumber }}
                    </p>
                    <s v-else class="info">{{ scope.row.examNumber }}</s>
                  </template>
                </el-table-column>
                <el-table-column label="報到時間">
                  <template slot-scope="">
                    00:00
                  </template>
                </el-table-column>
                <el-table-column label="考試成績">
                  <template slot-scope="scope">
                    {{ scope.row.score }}
                  </template>
                </el-table-column>
                <el-table-column label="證照號碼" width="110">
                  <template slot-scope="scope">
                    {{ scope.row.certNumber }}
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分頁 -->
              <div class="pagination">
                <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page="currentPage3" :page-sizes="[10, 50, 100]" :page-size="pagesize" layout="total, sizes,prev, pager, next" :total="reTrainingRecordList.length" prev-text="上一頁" next-text="下一頁"> </el-pagination>
              </div>
            </el-tab-pane>
            <!-- #endregion -->
          </el-tabs>
        </el-row>
      </el-col>
    </el-row>
    <!-- #endregion -->

    <!-- #region 新增培訓 彈窗 -->
    <el-dialog title="新增" :visible.sync="trainingRecordForm.dialogVisible" width="40%" @closed="CloseTrainingRecordDialog()" :close-on-click-modal="false">
      <el-form :model="trainingRecordForm.data" :rules="trainingRecordForm.rules" status-icon ref="trainingRecordForm" label-width="100px" class="demo-ruleForm" v-loading.lock="trainingRecordForm.loading">
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="trainingRecordForm.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="培訓單位" prop="host">
          <el-input v-model.trim="trainingRecordForm.data.host" type="text" autocomplete="off" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="講師" prop="lecturerName">
          <el-input v-model.trim="trainingRecordForm.data.lecturerName" type="text" autocomplete="off" maxlength="15" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="時數" prop="hours">
          <el-input v-model.trim="trainingRecordForm.data.hours" type="text" autocomplete="off" maxlength="4" show-word-limit></el-input>
        </el-form-item>
        <!-- 錯誤訊息 -->
        <el-form-item label="" prop="">
          <el-alert v-show="trainingRecordForm.errorMessage.length > 0" type="error" :closable="false">{{ trainingRecordForm.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="trainingRecordForm.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="CreateTarningRecord()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- #endregion -->

    <!-- #region 更新培訓 彈窗 -->
    <el-dialog title="更新" :visible.sync="trainingRecordFormUpdate.dialogVisible" width="40%" @closed="CloseTrainingRecordUpdateDialog()" :close-on-click-modal="false">
      <el-form :model="trainingRecordFormUpdate.data" :rules="trainingRecordFormUpdate.rules" status-icon ref="trainingRecordFormUpdate" label-width="100px" class="demo-ruleForm" v-loading.lock="trainingRecordFormUpdate.loading">
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="trainingRecordFormUpdate.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="培訓單位" prop="host">
          <el-input v-model.trim="trainingRecordFormUpdate.data.host" type="text" autocomplete="off" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="講師" prop="lecturerName">
          <el-input v-model.trim="trainingRecordFormUpdate.data.lecturerName" type="text" autocomplete="off" maxlength="15" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="時數" prop="hours">
          <el-input v-model.trim="trainingRecordFormUpdate.data.hours" type="text" autocomplete="off" maxlength="4" show-word-limit></el-input>
        </el-form-item>
        <!-- 錯誤訊息 -->
        <el-form-item label="" prop="">
          <el-alert v-show="trainingRecordFormUpdate.errorMessage.length > 0" type="error" :closable="false">{{ trainingRecordFormUpdate.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="trainingRecordFormUpdate.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="UpdateTrainingRecord()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- #endregion -->

    <!-- #region 新增複訓 彈窗 -->
    <el-dialog title="新增" :visible.sync="reTrainingRecordForm.dialogVisible" width="30%" @closed="CloseReTrainingRecordDialog()" :close-on-click-modal="false">
      <el-form :model="reTrainingRecordForm.data" :rules="reTrainingRecordForm.rules" status-icon ref="reTrainingRecordForm" label-width="100px" class="demo-ruleForm" v-loading.lock="reTrainingRecordForm.loading">
        <el-form-item label="日期" prop="dateFormate">
          <el-date-picker v-model="reTrainingRecordForm.data.dateFormate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>

        <!-- 錯誤訊息 -->
        <el-form-item label="" prop="">
          <el-alert v-show="reTrainingRecordForm.errorMessage.length > 0" type="error" :closable="false">{{ reTrainingRecordForm.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="reTrainingRecordForm.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="CreateReTarningRecord()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- #endregion -->

    <!-- #region 編輯複訓 彈窗 -->
    <el-dialog title="新增" :visible.sync="reTrainingRecordFormUpdate.dialogVisible" width="30%" @closed="CloseReTrainingRecordDialog()" :close-on-click-modal="false">
      <el-form :model="reTrainingRecordFormUpdate.data" :rules="reTrainingRecordFormUpdate.rules" status-icon ref="reTrainingRecordFormUpdate" label-width="100px" class="demo-ruleForm" v-loading.lock="reTrainingRecordFormUpdate.loading">
        <el-form-item label="日期" prop="dateFormate">
          <el-date-picker v-model="reTrainingRecordFormUpdate.data.dateFormate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>

        <!-- 錯誤訊息 -->
        <el-form-item label="" prop="">
          <el-alert v-show="reTrainingRecordFormUpdate.errorMessage.length > 0" type="error" :closable="false">{{ reTrainingRecordFormUpdate.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="reTrainingRecordFormUpdate.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="UpdateReTarningRecord()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- #endregion -->
  </el-main>
</template>

<script>
import {
  C_UserInfo_GetUserInfo, C_Certificate_GetList, C_UserInfo_Update, C_Certificate_Update, C_TrainingRecord_GetBackList, C_ReTrainingRecord_GetBackList, C_ExamInfo_GetBackUserList, C_TrainingRecord_Add, C_TrainingRecord_Update, C_TrainingRecord_DeleteList, C_ReTrainingRecord_Add, C_ReTrainingRecord_Update, C_ReTrainingRecord_DeleteList,
} from '@/assets/js/api';
import PictureUploader from '@/components/PictureUploader.vue';

export default {
  data() {
    return {
      userInfo: {},
      originalPhotoUrl: '',
      certificateList: [],
      fileList: [],
      trainingRecordList: [],
      reTrainingRecordList: [],
      examInfoList: [],
      cfileList: [],
      originalCertUrl: [],
      active: 0,
      loading: false,
      loading2: false,
      loading3: false,

      multipleSelection: [],
      multipleSelection2: [],
      multipleSelection3: [],
      currentPage: 1, // 默認顯示第一頁
      currentPage2: 1, // 默認顯示第一頁
      currentPage3: 1, // 默認顯示第一頁
      pagesize: 10, //    每頁顯示筆數
      trainingRecordForm: {
        dialogVisible: false,
        loading: false,
        formRef: 'trainingRecordForm',
        errorMessage: '',
        data: {
          date: '',
          host: '',
          lecturerName: '',
          hours: 0,
        },
        rules: {
          date: [{ required: true, message: '請輸入日期' }],
          host: [
            { required: true, message: '請輸入消息內容' },
            { min: 1, max: 50, message: '標題必須在50個字元內' },
          ],
          lecturerName: [
            { required: true, message: '請輸入消息內容' },
            { min: 1, max: 15, message: '標題必須在15個字元內' },
          ],
          hours: [
            { required: true, message: '請輸入時數' },
            { min: 1, max: 4, message: '標題必須在4個字元內' },
          ],
        },
      },
      trainingRecordFormUpdate: {
        dialogVisible: false,
        loading: false,
        formRef: 'trainingRecordFormUpdate',
        errorMessage: '',
        data: {
          id: '',
          date: '',
          host: '',
          lecturerName: '',
          hours: null,
        },
        rules: {
          date: [{ required: true, message: '請輸入日期' }],
          host: [
            { required: true, message: '請輸入消息內容' },
            { min: 1, max: 50, message: '標題必須在50個字元內' },
          ],
          lecturerName: [
            { required: true, message: '請輸入消息內容' },
            { min: 1, max: 15, message: '標題必須在15個字元內' },
          ],
          hours: [{ required: true, message: '請輸入時數' }],
        },
      },
      reTrainingRecordForm: {
        dialogVisible: false,
        loading: false,
        formRef: 'reTrainingRecordForm',
        errorMessage: '',
        data: {
          dateFormate: '',
        },
        rules: {
          dateFormate: [{ required: true, message: '請輸入日期' }],
        },
      },
      reTrainingRecordFormUpdate: {
        dialogVisible: false,
        loading: false,
        formRef: 'reTrainingRecordFormUpdate',
        errorMessage: '',
        data: {
          dateFormate: '',
        },
        rules: {
          dateFormate: [{ required: true, message: '請輸入日期' }],
        },
      },
    };
  },
  components: {
    PictureUploader,
  },
  mounted() {
    this.getUserInfos();
    this.getCertificateInfoList();
    this.TrainingRecordGetBackList(this.$route.params.userId);
    this.ReTrainingRecordGetBackList(this.$route.params.userId);
    this.ExamInfoGetBackUserList(this.$route.params.userId);
  },
  watch: {
    fileList() {
      if (this.fileList.length > 0) this.userInfo.photoUrl = this.fileList[0].url;
      if (this.fileList.length < 1) this.userInfo.photoUrl = this.originalPhotoUrl;
    },
    cfileList() {
      console.log(this.cfileList);
      if (this.cfileList.length > 0) this.certificateList[this.active].photoUrl = this.cfileList[0].url;
      if (this.cfileList.length < 1) {
        this.certificateList[this.active].photoUrl = this.originalCertUrl[this.active];
      }
    },
    active() {
      this.cfileList = '';
      this.certificateList[this.active].photoUrl = this.originalCertUrl[this.active];
    },
  },

  methods: {
    // GET 會員資料
    getUserInfos() {
      C_UserInfo_GetUserInfo(this.$route.params.userId)
        .then((res) => {
          this.userInfo = res.data.data;
          this.userInfo.birthday = this.userInfo.birthday.substring(0, 10).replace(/-/g, '/');
          if (this.userInfo.email === 'null') this.userInfo.email = null;
          this.originalPhotoUrl = this.userInfo.photoUrl;
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: '失敗',
            message: err,
            type: 'error',
          });
        });
    },
    // GET 證照資料
    getCertificateInfoList() {
      C_Certificate_GetList(this.$route.params.userId)
        .then((res) => {
          console.log(res.data.data);
          this.certificateList = res.data.data;
          const urlList = [];
          this.certificateList.forEach((element) => {
            urlList.push(element.photoUrl);
          });
          this.originalCertUrl = urlList;

          for (let i = 0; i <= this.certificateList.length - 1; i += 1) {
            this.certificateList[i].date = this.certificateList[i].date.substring(0, 10).replace(/-/g, '/');
            this.certificateList[i].term = this.certificateList[i].term.substring(0, 10).replace(/-/g, '/');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        });
    },
    // UPDATE 會員資料
    updateUserInfos() {
      const userForm = new FormData();
      userForm.append('name', this.userInfo.name);
      userForm.append('gender', this.userInfo.gender);
      userForm.append('phone', this.userInfo.phone);
      userForm.append('birthday', this.userInfo.birthday);
      userForm.append('email', this.userInfo.email);
      userForm.append('address', this.userInfo.address);
      if (this.fileList.length > 0) userForm.append('photoFile', this.fileList[0].raw);

      C_UserInfo_Update(this.$route.params.userId, userForm)
        .then((res) => {
          console.log(res.data.data);
          this.$notify({
            title: '成功',
            message: '個人資訊更新成功',
            type: 'success',
          });
          this.getUserInfos();
          this.fileList = [];
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: '失敗',
            message: err,
            type: 'error',
          });
        });
    },
    // UPDATE 證照資料
    updateCertificateInfos() {
      const cUserForm = new FormData();
      cUserForm.append('issueHost', this.certificateList[this.active].issueHost);
      cUserForm.append('date', this.certificateList[this.active].date);
      if (this.cfileList.length > 0) cUserForm.append('photoFile', this.cfileList[0].raw);

      C_Certificate_Update(this.certificateList[this.active].id, cUserForm)
        .then((res) => {
          console.log(res.data.data);
          this.$notify({
            title: '成功',
            message: '證照資訊更新成功',
            type: 'success',
          });
          this.getCertificateInfoList();
          this.cfileList = [];
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: '失敗',
            message: err.response.data.message,
            type: 'error',
          });
        });
    },

    // #region  培訓紀錄 API

    // --- 新增 ---
    // GET培訓紀錄 list
    TrainingRecordGetBackList(userId) {
      this.loading = true;
      C_TrainingRecord_GetBackList(userId)
        .then((res) => {
          console.log(res.data.data);
          this.trainingRecordList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // CLOSE 新增培訓紀錄 彈窗
    CloseTrainingRecordDialog() {
      this.trainingRecordForm.loading = false;
      this.$refs[this.trainingRecordForm.formRef].resetFields();
      this.trainingRecordForm.errorMessage = '';
    },
    // 新增培訓紀錄 API
    CreateTarningRecord() {
      this.$refs[this.trainingRecordForm.formRef].validate((valid) => {
        if (valid) {
          this.trainingRecordForm.loading = true;
          this.trainingRecordForm.errorMessage = '';
          this.trainingRecordForm.data.userId = this.$route.params.userId;
          // 新增培訓紀錄 API
          C_TrainingRecord_Add(this.trainingRecordForm.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.trainingRecordForm.dialogVisible = false;
            })
            .catch((err) => {
              this.trainingRecordForm.errorMessage = err.response.data.message;
            })
            .finally(() => {
              this.trainingRecordForm.loading = false;
              this.TrainingRecordGetBackList(this.$route.params.userId);
            });
        }
      });
    },

    // --- 編輯 ---
    // OPEN 編輯培訓紀錄 彈窗
    EditTrainingRecord(id) {
      const targetData = this.trainingRecordList.filter((x) => x.id === id)[0];
      this.trainingRecordFormUpdate.data = targetData;
      this.trainingRecordFormUpdate.dialogVisible = true;
    },
    // 更新培訓紀錄 API
    UpdateTrainingRecord() {
      this.$refs[this.trainingRecordFormUpdate.formRef].validate((valid) => {
        if (valid) {
          this.trainingRecordFormUpdate.loading = true;
          this.trainingRecordFormUpdate.errorMessage = '';
          // 更新培訓紀錄 API
          C_TrainingRecord_Update(this.trainingRecordFormUpdate.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
              });
              this.trainingRecordFormUpdate.dialogVisible = false;
            })
            .catch((err) => {
              this.$notify({
                title: '更新失敗',
                message: err.response.data.message,
                type: 'error',
              });
            })
            .finally(() => {
              this.trainingRecordFormUpdate.loading = false;
              this.TrainingRecordGetBackList(this.$route.params.userId);
            });
        }
      });
    },

    // --- 刪除 ---
    // 刪除培訓 Dialog
    DeleteTrainingRecored() {
      if (this.multipleSelection.length < 1) {
        this.$confirm('請先選擇資料後再操作', '')
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm(`確定刪除 ${this.multipleSelection.length} 筆培訓嗎?`, '刪除')
          .then(() => {
            this.TrainingRecordDeleteListAPI();
          })
          .catch(() => {});
      }
    },
    // 刪除培訓 API
    TrainingRecordDeleteListAPI() {
      const selectedIds = this.multipleSelection.map((x) => x.id);
      const jsonObj = { multId: selectedIds };
      C_TrainingRecord_DeleteList(jsonObj)
        .then((res) => {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '刪除失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.TrainingRecordGetBackList(this.$route.params.userId);
        });
    },
    // #endregion

    // #region 複訓紀錄 API

    // --- 新增 ---
    // GET 複訓紀錄 list
    ReTrainingRecordGetBackList(userId) {
      this.loading2 = true;
      C_ReTrainingRecord_GetBackList(userId)
        .then((res) => {
          console.log(res.data.data);
          this.reTrainingRecordList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading2 = false;
        });
    },
    // CLOSE 新增複訓紀錄 彈窗
    CloseReTrainingRecordDialog() {
      this.reTrainingRecordForm.loading = false;
      this.$refs[this.reTrainingRecordForm.formRef].resetFields();
      this.reTrainingRecordForm.errorMessage = '';
    },
    // 新增複訓紀錄
    CreateReTarningRecord() {
      this.$refs[this.reTrainingRecordForm.formRef].validate((valid) => {
        if (valid) {
          this.reTrainingRecordForm.loading = true;
          this.reTrainingRecordForm.errorMessage = '';
          this.reTrainingRecordForm.data.userId = this.$route.params.userId;
          // 新增培訓紀錄 API
          C_ReTrainingRecord_Add(this.reTrainingRecordForm.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.reTrainingRecordForm.dialogVisible = false;
            })
            .catch((err) => {
              this.reTrainingRecordForm.errorMessage = err.response.data.message;
            })
            .finally(() => {
              this.reTrainingRecordForm.loading = false;
              this.ReTrainingRecordGetBackList(this.$route.params.userId);
            });
        }
      });
    },

    // --- 編輯 ---
    // OPEN 更新複訓紀錄 Dialog
    EditReTrainingRecord(id) {
      const reTargetData = this.reTrainingRecordList.filter((x) => x.id === id)[0];
      this.reTrainingRecordFormUpdate.data = reTargetData;
      this.reTrainingRecordFormUpdate.dialogVisible = true;
    },
    // 編輯複訓紀錄
    UpdateReTarningRecord() {
      this.$refs[this.reTrainingRecordFormUpdate.formRef].validate((valid) => {
        if (valid) {
          this.reTrainingRecordFormUpdate.loading = true;
          this.reTrainingRecordFormUpdate.errorMessage = '';
          // 更新培訓紀錄 API
          C_ReTrainingRecord_Update(this.reTrainingRecordFormUpdate.data)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
              });
              this.reTrainingRecordFormUpdate.dialogVisible = false;
            })
            .catch((err) => {
              this.$notify({
                title: '更新失敗',
                message: err.response.data.message,
                type: 'error',
              });
            })
            .finally(() => {
              this.reTrainingRecordFormUpdate.loading = false;
              this.ReTrainingRecordGetBackList(this.$route.params.userId);
            });
        }
      });
    },

    // --- 刪除 ---
    // 刪除複訓 Dialog
    DeleteReTrainingRecored() {
      if (this.multipleSelection2.length < 1) {
        this.$confirm('請先選擇資料後再操作', '')
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm(`確定刪除 ${this.multipleSelection2.length} 筆培訓嗎?`, '刪除')
          .then(() => {
            this.ReTrainingRecordDeleteListAPI();
          })
          .catch(() => {});
      }
    },
    // 刪除複訓 API
    ReTrainingRecordDeleteListAPI() {
      const reSelectedIds = this.multipleSelection2.map((x) => x.id);
      const rejsonObj = { multId: reSelectedIds };
      C_ReTrainingRecord_DeleteList(rejsonObj)
        .then((res) => {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '刪除失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.ReTrainingRecordGetBackList(this.$route.params.userId);
        });
    },
    // #endregion

    // #region 考試資訊 API
    // GET 考試資訊 list
    ExamInfoGetBackUserList(userId) {
      this.loading3 = true;
      C_ExamInfo_GetBackUserList(userId)
        .then((res) => {
          console.log(res.data.data);
          this.examInfoList = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading3 = false;
        });
    },
    // #endregion

    // #region 培訓紀錄FUNC
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(size) {
      this.pagesize = size;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    // #endregion

    // #region 複訓紀錄FUNC
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    handleSizeChange2(size) {
      this.pagesize = size;
    },
    handleCurrentChange2(currentPage) {
      this.currentPage2 = currentPage;
    },
    // #endregion

    // #region 複訓紀錄FUNC
    handleSelectionChange3(val) {
      this.multipleSelection3 = val;
    },
    handleSizeChange3(size) {
      this.pagesize = size;
    },
    handleCurrentChange3(currentPage) {
      this.currentPage3 = currentPage;
    },
    // #endregion

    cancal() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.block-div {
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #0089fa10;
  margin: 20px 0;
}
.upload-div {
  margin: 0 40px 0 0;
}
.userInfo-img {
  width: 250px;
  height: 250px;
  object-fit: contain;
}
.certStatusF {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;

  position: static;
  width: 48px;
  height: 38px;
  left: 75px;
  top: 3px;

  /* Color/Slate100 */

  background: #fef0f0;

  /* Color/Slate200 */

  border: 1px solid #facece;
  box-sizing: border-box;
  border-radius: 4px;

  color: #f56c6c;
}
.certStatusT {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;

  position: static;
  width: 48px;
  height: 38px;
  left: 75px;
  top: 3px;

  /* Color/Slate100 */

  background: #f4f4f5;
  /* Color/Slate200 */

  border: 1px solid #e9e9eb;
  box-sizing: border-box;
  border-radius: 4px;

  color: #909399;
}
.pagination {
  margin: 24px 0 0 0;
  text-align: center;
}
</style>
